module.exports = ".offering {\r\n    background-color: #ffd1dc;\r\n}\r\n"